export default __webpack_public_path__ + "static/media/main-background.402b38a3.svg";